export default "/_next/static/images/77bd9bafa54e2780a1ab641216e1e20a.png";